import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { ToastTypes, withToast } from "../contexts/toastr.context";
import { Loader } from "../_components/loader.component";
import OverviewAnalyticsCard from "../_components/overview-analytics.component";
import { DashboardService } from "../_service/dashboard.service";

export const DASHBOARD_ROUTE = "/";

function DashboardPageComponent({ addToast, organization, history }) {
  return (
    <div className="DashboardPage page-container ml-auto py-6 px-9 dashboard-container">
      <OverviewAnalyticsCard addToast={addToast} history={history} />
    </div>
  );
}

const mapStateToProps = (state) => ({
  user: state.auth,
  organization: state.orgData,
});

const DashboardPage = withToast(
  connect(mapStateToProps)(DashboardPageComponent)
);

export default DashboardPage;
